(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vonn-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const controllers = new Map();
  function init(scope) {
    scope.querySelectorAll('.vn-nav').forEach(nav => {
      const host = nav.closest('.shopify-section');
      if (!host || controllers.has(host)) return;
      const aborter = new AbortController();
      const signal = aborter.signal;
      const mobile = matchMedia('(max-width:749px)');
      let previous = Math.max(0, window.scrollY);
      let distance = 0;
      let direction = 0;
      let pending = false;
      host.classList.add('vn-scroll-header');
      const reveal = () => host.removeAttribute('data-scroll-hidden');
      function update() {
        pending = false;
        const maximum = Math.max(0, document.documentElement.scrollHeight - innerHeight);
        const current = Math.max(0, Math.min(window.scrollY, maximum));
        const delta = current - previous;
        previous = current;
        if (!mobile.matches || current <= nav.offsetHeight || nav.querySelector('details[open]') || nav.contains(document.activeElement)) {
          reveal();
          distance = 0;
          return;
        }
        const nextDirection = Math.sign(delta);
        if (!nextDirection) return;
        if (nextDirection !== direction) distance = 0;
        direction = nextDirection;
        distance += Math.abs(delta);
        if (distance >= 8) {
          host.toggleAttribute('data-scroll-hidden', direction > 0);
          distance = 0;
        }
      }
      function scroll() {
        if (pending) return;
        pending = true;
        requestAnimationFrame(update);
      }
      window.addEventListener('scroll', scroll, { passive:true, signal });
      window.addEventListener('pageshow', () => { previous = Math.max(0, scrollY); reveal(); }, { signal });
      mobile.addEventListener('change', () => { previous = Math.max(0, scrollY); distance = 0; reveal(); }, { signal });
      nav.addEventListener('focusin', reveal, { signal });
      nav.querySelectorAll('details').forEach(menu => menu.addEventListener('toggle', () => {
        previous = Math.max(0, scrollY);
        distance = 0;
        if (menu.open) reveal();
      }, { signal }));
      controllers.set(host, aborter);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.get(event.target)?.abort();
    controllers.delete(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vonn-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('.v-mobile-menu a');
  if (link) link.closest('details').removeAttribute('open');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vonn-offers"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',function(e){if(!e.target.matches('.vn-offers-switch input'))return;var root=e.target.closest('.vn-offers-clean');if(!root)return;var term=e.target.value;root.querySelectorAll('.vn-offers-terms').forEach(function(el){el.style.display=el.dataset.term===term?'block':'none'});root.querySelectorAll('.vn-offer-clean').forEach(function(card){var base=parseFloat(card.dataset.monthly||'0'),discount=parseFloat(card.dataset.discount||'20'),out=card.querySelector('.vn-price-value');var noteM=card.querySelector('[data-term="monthly"]'),noteQ=card.querySelector('[data-term="quarterly"]');if(out)out.textContent=(term==='quarterly'?base*(1-discount/100):base).toFixed(2).replace('.',',');if(noteM)noteM.style.display=term==='monthly'?'block':'none';if(noteQ)noteQ.style.display=term==='quarterly'?'block':'none';});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vonn-players"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const normalize=value=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase('fr').trim();
 const init=scope=>scope.querySelectorAll('[data-players]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const search=root.querySelector('[data-player-search]'),level=root.querySelector('[data-player-level]'),hand=root.querySelector('[data-player-hand]'),rows=[...root.querySelectorAll('[data-player-row]')],count=root.querySelector('[data-player-count]'),empty=root.querySelector('[data-player-empty]');
  const entries=rows.map(row=>({row,text:normalize(row.textContent)}));
  const filter=()=>{const terms=normalize(search.value).split(/\s+/).filter(Boolean);let found=0;entries.forEach(({row,text})=>{const show=terms.every(term=>text.includes(term))&&(!level?.value||row.dataset.level===level.value)&&(!hand?.value||row.dataset.hand===hand.value);row.hidden=!show;if(show)found++;});count.textContent=String(found);empty.hidden=found!==0;};
  search.addEventListener('input',filter);level?.addEventListener('change',filter);hand?.addEventListener('change',filter);
  root.querySelector('[data-player-reset]').addEventListener('click',()=>{search.value='';if(level)level.value='';if(hand)hand.value='';filter();search.focus();});
  root.querySelector('[data-player-tools]').hidden=false;filter();
  if(window.Shopify?.designMode){try{const id=sessionStorage.getItem('vonn-passport-'+root.dataset.sectionKey);const target=id&&document.getElementById(id);if(target&&root.contains(target))location.hash=id;}catch{}}
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
 const showPassport=()=>{const target=document.getElementById(location.hash.slice(1));if(target?.matches('[data-passport]'))target.querySelector('h1')?.focus({preventScroll:true});};
 window.addEventListener('hashchange',showPassport);
 document.addEventListener('shopify:section:select',event=>{const root=event.target.querySelector('[data-players]');if(!root)return;try{sessionStorage.removeItem('vonn-passport-'+root.dataset.sectionKey);}catch{}location.hash='annuaire-'+root.dataset.sectionKey;});
 document.addEventListener('shopify:block:select',event=>{const root=event.target.closest('[data-players]');if(!root)return;const passport=[...root.querySelectorAll('[data-passport]')].find(item=>item.dataset.blockId===event.detail.blockId);if(passport){try{sessionStorage.setItem('vonn-passport-'+root.dataset.sectionKey,passport.id);}catch{}location.hash=passport.id;passport.scrollIntoView({block:'start'});}});
})();

  } catch(e) { console.error(e); }
})();
})();
